import {i18n} from "@/plugins/i18n";

export const Roles = {
    SUPPORT: 'support',
    TECH_SUPPORT: 'tech-support',
    SYSTEM_ADMIN: 'system-admin',
    ACCOUNTANT: 'accountant',
    STAFF: 'staff',
    WALLET_OPERATOR: 'wallet-operator',
    BUSINESS_MANAGEMENT: 'business-management',
};

export const RolesArray = [
    {
        key: Roles.SUPPORT,
        value: i18n.t('label.roles.' + Roles.SUPPORT)
    },
    {
        key: Roles.TECH_SUPPORT,
        value: i18n.t('label.roles.' + Roles.TECH_SUPPORT)
    },
    {
        key: Roles.SYSTEM_ADMIN,
        value: i18n.t('label.roles.' + Roles.SYSTEM_ADMIN)
    },
    {
        key: Roles.ACCOUNTANT,
        value: i18n.t('label.roles.' + Roles.ACCOUNTANT)
    },
    {
        key: Roles.STAFF,
        value: i18n.t('label.roles.' + Roles.STAFF)
    },
    {
        key: Roles.WALLET_OPERATOR,
        value: i18n.t('label.roles.' + Roles.WALLET_OPERATOR)
    },
    {
        key: Roles.BUSINESS_MANAGEMENT,
        value: i18n.t('label.roles.' + Roles.BUSINESS_MANAGEMENT)
    },
];